function collVariant() {
  var products = $(".custom-product-form");
  products.each(function () {
    var field = $(this);
    var current_variant = parseInt($(this).find('[name="id"]').val());
    var script = $(this).find('script[type="application/json"]');
    script = JSON.parse(script.text());
    var selected_option = script.find((item) => {
      if (item.id == current_variant) {
        return item.title;
      }
    });
    selected_option.options.forEach(function (item) {
      field.find('input[value="' + item + '"]').prop("checked", true);
    });
  });
  products.find('input[type="radio"]').change(function (e) {
    var product_form = $(this).closest(".custom-product-form");
    var selected_option = product_form.find(
      'input[type="radio"]:checked'
    );
    selected_option = selected_option.map((index, item) => {
      return item.getAttribute("value");
    });
    var script = product_form.find('script[type="application/json"]');
    script = JSON.parse(script.text());
    var current_variant = "";
    try {
      script.forEach(function (item) {
        var matched = false;
        try {
          item.options.forEach(function (options, index) {
            if (options == selected_option[index]) {
              matched = true;
            } else {
              matched = false;
              throw new Error("Break inner the loop.");
            }
          });
        } catch (error) {
          // console.log(error);
        }

        if (matched == true) {
          current_variant = item;
          // console.log(item);
          throw new Error("Break the loop.");
        }
      });
    } catch (error) {
      // console.log(error);
    }
    if (current_variant == "") {
      product_form.find(".quick-add__submit>span").addClass("hidden");
      product_form
        .find(".quick-add__submit .sold-out-message")
        .removeClass("hidden");
    } else {
      product_form.find(".quick-add__submit>span").removeClass("hidden");
      product_form
        .find(".quick-add__submit .sold-out-message")
        .addClass("hidden");
      product_form.find('[name="id"]').val(current_variant.id);
      // console.log(current_variant);
    }
  });
}

function initializeVariantSelections() {
  // console.log('Initializing variant selections');
  document.querySelectorAll('.custom-product-form').forEach(form => {
    try {
      // Find first available variant
      const firstAvailableVariant = (
        JSON.parse(form.querySelector('script[type="application/json"]').textContent)
      ).find(variant => variant.available);
      
      if (!firstAvailableVariant) {
        return;
      }

      // Select first available variant's options
      firstAvailableVariant.options.forEach((optionValue, index) => {
        const input = form.querySelector(`input[value="${optionValue}"]`);
        input && (input.checked = true);
      });

      // Update hidden variant ID input
      const variantIdInput = form.querySelector('input[name="id"]');
      variantIdInput && (variantIdInput.value = firstAvailableVariant.id);

      // Update button state
      const submitButton = form.querySelector('button[type="submit"]');
      submitButton && (submitButton.disabled = !firstAvailableVariant.available);
      submitButton && (submitButton.querySelector('span').textContent = firstAvailableVariant.available ? 'Add to Bag' : 'Sold out');
      
    } catch (e) { console.error('Error in initializeVariantSelections for form:', e); }
  });
}

function initializeCardColorSwatches() {
  // Hide color selectors in quick-add forms when card has color swatches
  // Also add class to card-information when no color swatches for inline price/rating
  document.querySelectorAll('.card-wrapper').forEach(cardWrapper => {
    const cardInformation = cardWrapper.querySelector('.card-information');
    const hasColorSwatches = cardWrapper.querySelector('.card__color-swatches-wrapper');
    
    if (hasColorSwatches) {
      const colorSelectors = cardWrapper.querySelectorAll('.custom-product-form .size-select-inner.main-Colour, .custom-product-form .size-select-inner.main-Color');
      colorSelectors.forEach(selector => {
        selector.style.display = 'none';
      });
    } else if (cardInformation) {
      // Add class for browsers that don't support :has()
      cardInformation.classList.add('no-color-swatches');
    }
  });
  
  document.querySelectorAll('.card__color-swatch').forEach(swatch => {
    swatch.addEventListener('click', function(e) {
      // Prevent navigation and stop propagation
      e.preventDefault();
      e.stopPropagation();
      
      const productId = this.getAttribute('data-product-id');
      const cardWrapper = this.closest('.card-wrapper');
      if (!cardWrapper) return false;
      
      // Find and prevent any parent links from navigating
      let parent = this.parentElement;
      while (parent && parent !== cardWrapper) {
        if (parent.tagName === 'A') {
          parent.addEventListener('click', function(ev) {
            ev.preventDefault();
            ev.stopPropagation();
          }, { once: true, capture: true });
        }
        parent = parent.parentElement;
      }
      
      // Update active state
      const allSwatches = cardWrapper.querySelectorAll('.card__color-swatch');
      allSwatches.forEach(s => s.classList.remove('card__color-swatch--active'));
      this.classList.add('card__color-swatch--active');
      
      // Update product image if variant has image
      const imageSrc = this.getAttribute('data-image-src');
      const imageSrcset = this.getAttribute('data-image-srcset');
      
      if (imageSrc && cardWrapper) {
        const mainImage = cardWrapper.querySelector('.card__media img');
        if (mainImage) {
          if (imageSrcset) {
            mainImage.setAttribute('srcset', imageSrcset);
          }
          mainImage.setAttribute('src', imageSrc);
        }
        
        // Also update secondary image if it exists
        const secondaryImage = cardWrapper.querySelector('.card__media img:nth-child(2)');
        if (secondaryImage && imageSrcset) {
          secondaryImage.setAttribute('srcset', imageSrcset);
          secondaryImage.setAttribute('src', imageSrc);
        }
      }
      
      // Update variant ID and selection in quick-add form
      const quickAddForm = cardWrapper.querySelector('.custom-product-form');
      if (quickAddForm) {
        const variantId = this.getAttribute('data-variant-id');
        if (!variantId) return;
        
        try {
          // Get variant data from JSON script
          const variantsScript = quickAddForm.querySelector('script[type="application/json"]');
          if (!variantsScript) return;
          
          const variants = JSON.parse(variantsScript.textContent);
          const selectedVariant = variants.find(v => v.id == parseInt(variantId));
          
          if (!selectedVariant) return;
          
          // Update variant ID input first
          const variantIdInput = quickAddForm.querySelector('input[name="id"]');
          if (variantIdInput) {
            variantIdInput.value = variantId;
            if (selectedVariant.available === false) {
              variantIdInput.setAttribute('disabled', 'disabled');
            } else {
              variantIdInput.removeAttribute('disabled');
            }
          }
          
          // Update radio buttons in quick-add form to match selected variant
          // This ensures the quick-add form shows the correct selection
          if (selectedVariant.options && selectedVariant.options.length > 0) {
            // Uncheck all radios first
            const allRadios = quickAddForm.querySelectorAll('input[type="radio"]');
            allRadios.forEach(radio => radio.checked = false);
            
            // Check the radios that match the selected variant's options
            selectedVariant.options.forEach((optionValue) => {
              // Find radio inputs that match this option value
              const matchingRadios = quickAddForm.querySelectorAll(`input[type="radio"][value="${optionValue}"]`);
              matchingRadios.forEach(radio => {
                radio.checked = true;
              });
            });
          }
          
          // Update button state
          const submitButton = quickAddForm.querySelector('button[type="submit"]');
          if (submitButton) {
            submitButton.disabled = !selectedVariant.available;
            const buttonText = submitButton.querySelector('span:not(.sold-out-message):not(.icon-wrap)');
            if (buttonText) {
              buttonText.textContent = selectedVariant.available ? 'Add to Bag' : 'Sold out';
            }
            
            // Update sold-out message visibility
            const soldOutMessage = submitButton.querySelector('.sold-out-message');
            if (soldOutMessage) {
              if (selectedVariant.available) {
                soldOutMessage.classList.add('hidden');
                const mainSpan = submitButton.querySelector('span:not(.sold-out-message):not(.icon-wrap)');
                if (mainSpan) mainSpan.classList.remove('hidden');
              } else {
                soldOutMessage.classList.remove('hidden');
                const mainSpan = submitButton.querySelector('span:not(.sold-out-message):not(.icon-wrap)');
                if (mainSpan) mainSpan.classList.add('hidden');
              }
            }
          }
          
          // Trigger the existing jQuery change handlers to sync everything
          if (typeof $ !== 'undefined' && typeof collVariant === 'function') {
            // Trigger change on the first checked radio to activate collVariant handler
            const checkedRadios = quickAddForm.querySelectorAll('input[type="radio"]:checked');
            if (checkedRadios.length > 0) {
              $(checkedRadios[0]).trigger('change');
            }
          }
          
        } catch (err) {
          console.error('Error updating variant selection:', err);
        }
      }
      
      // Return false to prevent any default behavior
      return false;
    });
  });
}

// Initialize color swatches on page load and after dynamic content loads
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeCardColorSwatches);
} else {
  initializeCardColorSwatches();
}

// Re-initialize after AJAX content loads (for collection filtering, etc.)
document.addEventListener('shopify:section:load', initializeCardColorSwatches);

// Price styles are now applied inline via Liquid, no JavaScript needed

// Apply rating color to star icon
function applyCardRatingStyles() {
  document.querySelectorAll('.rating').forEach(rating => {
    // Check if rating has inline color style (set by Liquid)
    if (rating.style.color) {
      const color = rating.style.color;
      const starIcon = rating.querySelector('.rating-star-icon');
      if (starIcon) {
        starIcon.style.color = color;
      }
    }
  });
}

// Set per-card --card-information-height so CSS can translateY(calc(100% - var(...))).
// Heights differ by title/rating/price; CSS alone cannot measure a child. Transform stays in custom.css.
function applyCardContentTransform() {
  document.querySelectorAll('.product-card-wrapper .card:not(.ratio) > .card__content').forEach(cardContent => {
    const cardInformation = cardContent.querySelector('.card__information--custom');
    if (cardInformation) {
      const height = cardInformation.offsetHeight;
      if (height > 0) {
        cardContent.style.setProperty('--card-information-height', `${height}px`);
      }
    }
  });
}

// Initialize all card styles on page load
function initializeCardStyles() {
  applyCardRatingStyles();
  applyCardContentTransform();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeCardStyles);
} else {
  initializeCardStyles();
}

document.addEventListener('shopify:section:load', initializeCardStyles);

// Recalculate on resize
let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    applyCardContentTransform();
  }, 100);
});

// Use capture phase to prevent parent link navigation when clicking color swatches
// This intercepts clicks on swatches before they reach parent links
document.addEventListener('click', function(e) {
  const swatch = e.target.closest('.card__color-swatch');
  if (swatch && (e.target === swatch || swatch.contains(e.target))) {
    // Find any parent links and prevent their navigation
    let element = e.target;
    while (element && element !== document.body) {
      if (element.tagName === 'A' && element.href) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      element = element.parentElement;
    }
  }
}, true);

function initializeCartRecommendations() {
  // console.log('Initializing cart recommendations');
  const recommendationForms = document.querySelectorAll('.cart_recomm .custom-product-form');
  
  recommendationForms.forEach(form => {
    try {
      // Get variant data
      const variantScript = form.querySelector('script[type="application/json"]');
      if (!variantScript) {
        console.log('No variant script found for form:', form);
        return;
      }

      const variants = JSON.parse(variantScript.textContent);
      // console.log('Variants data:', variants);

      // Find first available variant
      const firstAvailableVariant = variants.find(variant => variant.available);
      if (!firstAvailableVariant) {
        return;
      }

      console.log('Selected variant:', firstAvailableVariant);

      // Select first available variant's options
      firstAvailableVariant.options.forEach((optionValue, index) => {
        const input = form.querySelector(`input[type="radio"][value="${optionValue}"]`);
        if (input) {
          input.checked = true;
          // console.log(`Selected option ${index}:`, optionValue);
        } else {
          console.log(`Could not find input for option ${index}:`, optionValue);
        }
      });

      // Update hidden variant ID input
      const variantIdInput = form.querySelector('input[name="id"]');
      if (variantIdInput) {
        variantIdInput.value = firstAvailableVariant.id;
        console.log('Updated variant ID to:', firstAvailableVariant.id);
      }

      // Update button state
      const submitButton = form.querySelector('.quick-add__submit');
      if (submitButton) {
        submitButton.disabled = !firstAvailableVariant.available;
        const buttonText = submitButton.querySelector('span');
        const soldOutMessage = submitButton.querySelector('.sold-out-message');
        
        if (firstAvailableVariant.available) {
          buttonText.classList.remove('hidden');
          soldOutMessage.classList.add('hidden');
        } else {
          buttonText.classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
        }
      }
    } catch (error) {
      console.error('Error initializing variants for form:', error);
    }
  });
}

function handleVariantChange(e) {
  const form = e.target.closest('.custom-product-form');
  if(!form) { return; }
  
  try {
    const variantScript = form.querySelector('script[type="application/json"]');
    if (!variantScript) return;

    const variants = JSON.parse(variantScript.textContent);
    const selectedOptions = Array.from(form.querySelectorAll('input[type="radio"]:checked')).map(input => input.value);
    
    // Find matching variant
    const matchingVariant = variants.find(variant => 
      variant.options.every((option, index) => option === selectedOptions[index])
    );

    if (matchingVariant) {
      // Update hidden variant ID input
      const variantIdInput = form.querySelector('input[name="id"]');
      if (variantIdInput) {
        variantIdInput.value = matchingVariant.id;
      }

      // Update button state based on availability
      const submitButton = form.querySelector('.quick-add__submit');
      if (submitButton) {
        const buttonText = submitButton.querySelector('span');
        const soldOutMessage = submitButton.querySelector('.sold-out-message');
        
        if (matchingVariant.available) {
          buttonText.classList.remove('hidden');
          soldOutMessage.classList.add('hidden');
          submitButton.removeAttribute('aria-disabled');
        } else {
          buttonText.classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          submitButton.setAttribute('aria-disabled', 'true');
        }
      }
    }
  } catch (error) {
    console.error('Error in handleVariantChange:', error);
  }
}

// Modify the cart_recomm function to use a more robust initialization approach
function cart_recomm() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer || !cartDrawer.productId) return;

  // Create an observer instance to watch for when recommendations are added
  const observer = new MutationObserver((mutations, obs) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        const recommendationsContainer = document.querySelector('.cart_recomm');
        if (recommendationsContainer) {
          const productForms = recommendationsContainer.querySelectorAll('.custom-product-form');
          if (productForms.length) {
            console.log('Found recommendation forms, initializing...');
            
            productForms.forEach(form => {
              try {
                // Get variant data
                const variantScript = form.querySelector('script[type="application/json"]');
                if (!variantScript) {
                  console.log('No variant script found');
                  return;
                }

                const variants = JSON.parse(variantScript.textContent);
                const firstAvailableVariant = variants.find(v => v.available);
                
                if (firstAvailableVariant) {
                  console.log('Found first available variant:', firstAvailableVariant);
                  
                  // Set the variant ID
                  const variantInput = form.querySelector('input[name="id"]');
                  if (variantInput) {
                    variantInput.value = firstAvailableVariant.id;
                  }

                  // Select the radio buttons
                  firstAvailableVariant.options.forEach((optionValue, index) => {
                    const radio = form.querySelector(`input[type="radio"][value="${optionValue}"]`);
                    if (radio) {
                      radio.checked = true;
                      // console.log(`Selected option ${index}:`, optionValue);
                    }
                  });

                  // Update button state
                  const submitButton = form.querySelector('.quick-add__submit');
                  if (submitButton) {
                    const buttonText = submitButton.querySelector('span');
                    const soldOutMessage = submitButton.querySelector('.sold-out-message');
                    
                    if (firstAvailableVariant.available) {
                      buttonText.classList.remove('hidden');
                      soldOutMessage.classList.add('hidden');
                      submitButton.removeAttribute('aria-disabled');
                    } else {
                      buttonText.classList.add('hidden');
                      soldOutMessage.classList.remove('hidden');
                      submitButton.setAttribute('aria-disabled', 'true');
                    }
                  }
                }
              } catch (error) {
                console.error('Error initializing form:', error);
              }
            });

            // Disconnect once we've handled the recommendations
            obs.disconnect();
          }
        }
      }
    }
  });

  // Start observing the document with the configured parameters
  observer.observe(document.body, { 
    childList: true, 
    subtree: true 
  });

}

// ON DOCUMENT READY
$(() => {
  setTimeout(() => {
    collVariant();
    cart_recomm();
    initializeVariantSelections();
    initializeCardColorSwatches();
  }, 1000);

  // open header on hover starts
  $(window).width() > 990 && $(".header__inline-menu ul li header-menu").hover(
    function () { $(this).children(".mega-menu").attr("open", "true") },
    function () { $(this).children(".mega-menu").removeAttr("open") }
  );
  
  $(document).on('change', '.custom-product-form input[type="radio"]', handleVariantChange);

  // Add event listeners for cart updates
  document.addEventListener('cart:updated', () => { setTimeout(cart_recomm, 100); });
  document.addEventListener('cart:refresh', () => { setTimeout(cart_recomm, 100); });
  document.addEventListener('cart:opened', () => { setTimeout(initializeCartRecommendations, 100); });
});